// extracted by mini-css-extract-plugin
export default {"container":"sYB7zA","fixedPositionContainer":"x4vpru","helpBtn":"UJ64Nq","gif":"zr380C"};